import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getOpsColor } from "../../../../utils/helper";
import { CircleClose } from "../../../Icons";
import Button from "../Button/Button";
import {
  StyledSectionDescription,
  StyledSectionTitle,
} from "../ScrollSection/ScrollSection-styled";
import {
  FileDelete,
  FilePreview,
  FilePreviewContainer,
  FileUpload,
  FileUploadText,
} from "./UploadFile-styled";

const UploadFile = ({
  form,
  setForm,
  name,
  config,
  title,
  description,
  fileDescription,
  assignUrl = false,
  isMulti = true,
  maxFiles,
}) => {
  const file = useMemo(() => form[name], [form, name]);
  const [previews, setPreviews] = useState([]);
  const objectUrl = useRef([]);
  const activeModule = useSelector((state) => state.activeModule);
  const { t } = useTranslation("common");
  useEffect(() => {
    // create the preview
    // let objectUrl
    // if (file) {
    //   objectUrl = URL.createObjectURL(file)
    //   setPreview(objectUrl)
    // }

    // free memory when ever this component is unmounted
    return () => {
      objectUrl.current.forEach((url) => {
        URL.revokeObjectURL(url);
      });

      objectUrl.current = [];
      setPreviews([]);
    };
  }, []);

  const onDrop = useCallback(
    (acceptedFiles) => {
      // const acceptedFiles = isMulti ? files : [files];
      const previews = [];

      acceptedFiles.forEach((file) => {
        const url = URL.createObjectURL(file);
        previews.push(url);
      });

      objectUrl.current = previews;

      setPreviews(previews);

      if (assignUrl) {
        setForm(name, previews);
      } else {
        setForm(name, acceptedFiles);
      }

      // const file = acceptedFiles[0];

      // // setForm(form=>({...form, [name]: acceptedFiles[0]}))
      // if (file) {
      //   objectUrl.current = URL.createObjectURL(file);
      //   setPreview(objectUrl.current);

      // if (assignUrl) {
      //     setForm(name, objectUrl.current);
      //   } else {
      //     setForm(name, file);
      //   }
      // }
    },
    [setForm, assignUrl]
  );

  const handleDelete = (e, index) => {
    e.stopPropagation();

    const newPreviews = previews.filter((url, i) => {
      if (i === index) {
        URL.revokeObjectURL(url);
      }

      return i !== index;
    });

    setPreviews(newPreviews);

    const newFile = file.filter((_, i) => i !== index);

    setForm(name, newFile.length > 0 ? newFile : null);

    objectUrl.current = newPreviews;
  };

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    accept: "image/jpeg,image/jpg,image/png",
    multiple: isMulti,
  });

  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );

  return (
    <>
      {title && (
        <StyledSectionTitle style={{ margin: "5px 0px 0px 0px" }}>
          {title}
        </StyledSectionTitle>
      )}
      {description && (
        <StyledSectionDescription style={{ margin: 0 }}>
          {description}
        </StyledSectionDescription>
      )}
      <FileUpload
        color={opsColor}
        isDragActive={isDragActive}
        {...getRootProps()}
      >
        <input accept="image/*" {...getInputProps()} />
        {!file ? (
          <>
            <Button bg="var(--opsColor)" onClick={open}>
              <svg
                width={18}
                height={18}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#fff"
                stroke="#fff"
              >
                <path
                  d="M24 12a5 5 0 0 1-5 5h-2v-1h2a3.99 3.99 0 0 0 .623-7.934l-.79-.124-.052-.798a5.293 5.293 0 0 0-10.214-1.57L8.17 6.59l-.977-.483A2.277 2.277 0 0 0 6.19 5.87a2.18 2.18 0 0 0-1.167.339 2.206 2.206 0 0 0-.98 1.395l-.113.505-.476.2A4 4 0 0 0 5 16h3v1H5a5 5 0 0 1-1.934-9.611 3.21 3.21 0 0 1 1.422-2.025 3.17 3.17 0 0 1 1.702-.493 3.268 3.268 0 0 1 1.446.34 6.293 6.293 0 0 1 12.143 1.867A4.988 4.988 0 0 1 24 12zm-11-1h-1v10.292l-2.646-2.646-.707.707 3.854 3.854 3.853-3.852-.707-.707L13 21.294z"
                  fill="#393838"
                />
              </svg>
              {!file && <span>{t("screen.actions.upload")}</span>}
            </Button>
            <FileUploadText isDragActive={isDragActive}>
              {fileDescription}
            </FileUploadText>
          </>
        ) : (
          previews.map((preview, index) => (
            <FilePreviewContainer key={preview}>
              <FilePreview src={preview} alt={file.name} />
              <FileDelete onClick={(e) => handleDelete(e, index)}>
                <CircleClose color={opsColor} />
              </FileDelete>
            </FilePreviewContainer>
          ))
        )}
      </FileUpload>
    </>
  );
};

export default UploadFile;
